import FormCheckbox from '@/components/molecules/FormCheckbox';
import { SearchFilterGeneralProps } from '../SearchFilterGeneralInfoSection/SearchFilterGeneralInfoSection';

const fuelTypeOptions = [
  { label: 'Battery Electric Vehicle (EV)', value: 'Electric' },
  { label: 'Plug-in Hybrid (PHEV)', value: 'Hybrid' },
];

export const SearchFilterFuelTypeSection: React.FC<
  SearchFilterGeneralProps
> = ({ updateFilter, filters }) => {
  return (
    <section className="flex flex-col gap-l pt-s">
      <section className="flex flex-col gap-s">
        <label className="text-body2Light text-neutral-800">
          <span className="block">Fuel type</span>
        </label>
        {fuelTypeOptions.map((option, index) => {
          return (
            <FormCheckbox
              key={index}
              className="flex w-full items-center justify-start rounded-[8px] bg-neutral-100 px-l py-m text-body2Light hover:bg-neutral-200"
              checkBoxStyle="size-[20px] border-[1px] rounded-xsmall"
              onChange={(evt) => {
                let fuelTypeArray = filters.fuelType
                  ? filters.fuelType.split(',')
                  : [];
                if (evt) {
                  fuelTypeArray.push(option.value);
                } else {
                  fuelTypeArray = fuelTypeArray.filter(
                    (fuelType) => fuelType !== option.value
                  );
                }
                updateFilter({
                  fields: {
                    fuelType: fuelTypeArray.join(','),
                  },
                });
              }}
              checked={filters.fuelType.includes(option.value)}
              checkboxLabel={option.label}
            />
          );
        })}
      </section>
    </section>
  );
};
